import axios from "axios";
import {API} from "@/services/url";
import {getOrFetch} from "@/services/cache";

export default {
	// Departments aren't written from this admin panel (managed via inovace-client-api), so
	// there's no local invalidation path — the 60s TTL is what bounds staleness here.
	getAllDepartments : function (officeId, success, error){
		getOrFetch('departmentList-' + officeId, 60000, () => axios.get(API.department.all + officeId))
			.then(r => success(r.data.departmentList))
			.catch(e => error(e.response.data.message));
	}
}
